import { GridOptions } from 'ag-grid-community';

import { ScenarioDetailsRenderer } from './scenarioDetailsRenderer.component';
import { EDITING_RULES } from '../constants';

export const masterGridOptions: GridOptions = {
  masterDetail: true,
  detailCellRenderer: 'ScenarioDetailsRenderer',
  components: {
    ScenarioDetailsRenderer,
  },
  isRowMaster: data => data.editable && Object.values(data.editable).some(({ type }: any) =>
    type && type !== EDITING_RULES.OVERRIDE
  ),
  suppressColumnMoveAnimation: true,
};
